const summary = {
  categories: [],
  total_count: 0,
  total_hours: 0
}

const groupBy = (events, key) => {
  return events.reduce((group, event) => {
    (group[event[key]] = group[event[key]] || []).push(event)
    return group
  }, {})
}

const maxEvents = (viewType) => {
  if (viewType == 'dayGridMonth')    return 4
  if (viewType == 'timeGridWeek')    return 2
  if (viewType == 'timeGridFourDay') return 3
}

const viewGrouping = (viewType) => {
  if (viewType == 'dayGridMonth') return 'day'
  if (viewType == 'timeGridWeek' || viewType == 'timeGridFourDay') return 'start'
}

const groupedEvent = (events) => {
  return {
    id: null,
    start: events[0].start,
    end: events[0].end,
    day: events[0].day,
    allDay: false,
    title: `${events.length} reservations`,
    className: 'collected'
  }
}

const groupEvents = (state, ungroupedEvents) => {
  var groupedEvents = groupBy(ungroupedEvents, viewGrouping(state.viewType))
  
  groupedEvents = [].concat.apply([], Object.entries(groupedEvents).map(([k, v]) => v.length > maxEvents(state.viewType) ? groupedEvent(v) : v))
  return {events: groupedEvents, ungroupedEvents: ungroupedEvents}
}

const validateEvent = (state, payload) => {
  var updatedEvents = state.ungroupedEvents

  const gameIndex = updatedEvents.findIndex((event) => { return event.id == payload.event.id })
  if (payload.event.cancelled) {
    updatedEvents = gameIndex == -1 ? updatedEvents : [
      ...state.ungroupedEvents.slice(0, gameIndex), 
      ...state.ungroupedEvents.slice(gameIndex + 1, state.ungroupedEvents.length)
    ]
  } else {
    gameIndex == -1 ? updatedEvents.push(payload.event) : updatedEvents = [
      ...state.ungroupedEvents.slice(0, gameIndex),
      payload.event,
      ...state.ungroupedEvents.slice(gameIndex + 1, state.ungroupedEvents.length)
    ]
  }

  return groupEvents(state, updatedEvents)
}

const validatedEvents = (state, payload) => {
  payload.events = payload.events.sort((a, b) => {
    return (a.start < b.start) ? -1 : ((a.start > b.start) ? 1 : 0)
  })

  return groupEvents(state, payload.events)
}

const updatedEvents = (state, payload) => {
  const events = state.events
  const eventIndex = events.findIndex(e => e.id == payload.message.game_id)
  if (eventIndex == -1) return events

  const newEvent = events[eventIndex]
  const message = payload.message
  if ('notes_count' in message) newEvent.icons = {...newEvent.icons, with_notes: message.notes_count > 0}
  if ('confirmed' in message) newEvent.icons = {...newEvent.icons, confirmed: message.confirmed}
  if ('players_count' in message || 'max_players' in message)
    newEvent.total = `${message.players_count}/${message.max_players}`

  return [ 
    ...events.slice(0, eventIndex),
    newEvent,
    ...events.slice(eventIndex + 1, events.length)
  ]
}

const calendar = (state = {}, {type, payload}) => {
  switch (type) {
    case 'CALENDAR.INIT':
      return {...state, events: [], ungroupedEvents: [], isLoading: true, summary: summary, compoundFieldsNames: payload.compoundFieldsNames,
        fieldMode: 'simple', viewType: payload.defaultView, fieldsData: payload.fieldsData, canCreate: payload.canCreate, alert: null,
        sdAdminLevel: payload.sdAdminLevel, minTime: payload.minTime, maxTime: payload.maxTime, initialDate: payload.initialDate,
        socketUrl: payload.socketUrl, timeFractions: payload.timeFractions, locationCode: payload.locationCode, googleCalendarId: payload.googleCalendarId}
    case 'CALENDAR.VIEW_TYPE_CHANGE':
      return {...state, viewType: payload}
    case 'CALENDAR.FIELD_MODE':
      return {...state, fieldMode: payload}
    case 'CALENDAR.FETCH_EVENTS':
      return {...state, ...validatedEvents(state, payload), isLoading: false}
    case 'CALENDAR.FETCH_SUMMARY':
      return {...state, summary: payload, isLoading: false}
    case 'CALENDAR.EVENT_UPDATE':
      return {...state, events: updatedEvents(state, payload)}
    case 'CALENDAR.VALIDATE_EVENT':
      return {...state, ...validateEvent(state, payload)}
    case 'CALENDAR.DATE_CHANGE':
      return {...state, isLoading: true}
    case 'CALENDAR.REMOVE_GOOGLE_EVENTS':
      return {...state, events: [...state.events.filter(e => e.category_name != 'Google')], isLoading: false }
    case 'SIGNATURE.START':
      if (_.isEmpty(state)) return state

      return {...state, signature: payload }
    case 'SIGNATURE.STOP':
      if (_.isEmpty(state)) return state

      return {...state, signature: null }
    case 'SIGNATURE.COMPLETE':
      return {...state, signature: {...state.signature, error: null} }
    case 'PAYMENT_ERROR':
      if (_.isEmpty(state) || !state.signature) return state

      return {...state, signature: {...state.signature, error: payload.error} }
    case 'PAYMENT_SUCCESS':
      if (_.isEmpty(state) || !state.signature) return state

      return {...state, signature: null }
    default:
      return state
  }
}

export default calendar
